import React, { Component } from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Menu, MenuItem } from "@mui/material";
// import moment from "moment";
import { Button, Form, Modal } from "react-bootstrap";
import BuildingsApi from "../../api/BuildingsApi";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import Avatar from "@mui/material/Avatar";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EnlargeImage from "../../customFunctions/EnlargeImage";
import getBaseUrl from "../../customFunctions/getBaseUrl";
import { API_URL } from "../../config/app-config";

class BuildingGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      selectedEditData: {},
      opendeleteproductDialogue: false,
      showViewServiceRecord: false,
      building_name : '',
      buildingImage :""
    };
  }



  render() {
    console.log("this.props.buildingList", this.props.buildingList);

    // const baseUrl = getBaseUrl();
    return (
      <>
        <div className="adjust-grid-container">
          <div className="Center-the-Grid">
            <table id="myTable">
              <thead>
                <tr style={{ borderBottom: "1px solid #BCBFBE" }}>
                  <th>Building Name</th>
                  <th>Year</th>
                  <th>Year Acquired</th>
                
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {this.props.buildingList.map((e) => (
                  <tr>
                    <td class="avatar-cell">
                      <div class="avatar">
                        <Avatar
                          onClick={() =>this.handleAvatarClick(e)}
                          alt={`${e.building_name}`}
                          src={
                            e.buildingImage !== null
                              ? `${API_URL}auth/assets/${
                                  e.buildingImage
                                }`
                              : null
                          }
                          sx={{
                            objectFit: "cover",
                            transition: "transform 0.3s ease-in-out", // Add a smooth transition effect
                            "&:hover": {
                              transform: "scale(1.8)",
                              zIndex: 2, // Example: Enlarge the image size on hover
                            },
                          }}
                          loading="lazy"
                        >
                          {e.buildingImage === null && (
                            <span>
                              {e.building_name.charAt(0).toUpperCase()}
                            </span>
                          )}
                        </Avatar>
                        <div className="name">
                          {e.building_name.charAt(0).toUpperCase() +
                            e.building_name.slice(1)}
                        </div>
                      </div>
                    </td>
                    <td>{e.year}</td>
                    <td>{e.year_acquired}</td>
                    {/* <td>{moment(e.createdDate).format("dddd, D MMMM YYYY")}</td> */}
                    <td>
                      {
                        <>
                          <MoreHorizIcon
                            onClick={(event) =>
                              this.handleFilterClick(event, e)
                            }
                          />{" "}
                          <Menu
                            anchorEl={this.state.anchorEl}
                            open={Boolean(this.state.anchorEl)}
                            onClose={this.handleFilterClose2}
                            className="exclude-menu"
                          >
                            <MenuItem
                              onClick={(e) => this.handleFilterClose("edit", e)}
                            >
                              <EditOutlinedIcon />{" "}
                              <span className="inisde-the-action">Edit</span>
                            </MenuItem>
                            <MenuItem
                              onClick={() => this.handleFilterClose("delete")}
                            >
                              <DeleteOutlinedIcon />{" "}
                              <span className="inisde-the-action">Delete</span>
                            </MenuItem>
                            <MenuItem
                              onClick={(e) =>
                                this.handleFilterClose("add-serviceRecord", e)
                              }
                            >
                              <AddCircleOutlineIcon />{" "}
                              <span className="inisde-the-action">
                                Add ServiceRecord
                              </span>
                            </MenuItem>

                            {this.state.showViewServiceRecord && (
                              <MenuItem
                                onClick={(e) =>
                                  this.handleFilterClose(
                                    "view-serviceRecord",
                                    e
                                  )
                                }
                              >
                                <VisibilityIcon />{" "}
                                <span className="inisde-the-action">
                                  View ServiceRecord
                                </span>
                              </MenuItem>
                            )}
                          </Menu>
                        </>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
              {this.props.buildingList.length === 0 && (
                <>
                  {" "}
                  <div
                    style={{
                      fontSize: "larger",
                      fontWeight: "bolder",
                      fontFamily: "Karla",
                    }}
                  >
                    {"No Data Found"}
                  </div>{" "}
                </>
              )}
            </table>
          </div>
        </div>
        {this.state.opendeleteproductDialogue && this.deleteproductPopUp()}
        {this.state.isModalOpen && (
          <EnlargeImage 
            onClose={this.handleModalClose} 
            imageUrl={this.state.buildingImage !== null ? `${API_URL}auth/assets/${this.state.buildingImage}` : null}
            />
          
        )}
      </>
    );
  }


  handleAvatarClick = (e) => {
    console.log("e in check", e);

    if (e.buildingImage !== null) {
      this.setState({
        isModalOpen: true,
        buildingImage: e.buildingImage,
        building_name: e.building_name,
      });
    }
  
  };

  handleModalClose = () => {
    this.setState({ isModalOpen: false });
  };

  handleFilterClick = (event, data) => {
    console.log("data", data);
    this.props.getBuildingName(data);
    this.setState({
      anchorEl: event.target,
      selectedEditData: data,
      showViewServiceRecord: data.allow,
    });
  };

  handleFilterClose2 = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleFilterClose = (getState) => {
    if (getState === "edit") {
      this.props.ActiveEdit(this.state.selectedEditData);
      this.handleFilterClose2();
    } else if (getState === "delete") {
      this.setState({
        opendeleteproductDialogue: true,
        anchorEl: null,
      });
    } else if (getState === "add-serviceRecord") {
      this.props.openCreateServiceRecord(this.state.selectedEditData);
    } else if (getState === "view-serviceRecord") {
      this.props.openListServiceRecord(this.state.selectedEditData);
    }

    this.setState({
      anchorEl: null,
    });
  };

  handleClose = () => {
    this.setState({ opendeleteproductDialogue: false });
  };

  deleteBuilding = () => {
    let obj = {
      building_id: this.state.selectedEditData.building_id,
    };

    BuildingsApi.deletebuilding(obj).then((response) => {
      if (response.data) {
        this.handleClose();
        this.props.editanddeleteload();
      }
    });
  };

  deleteproductPopUp = () => {
    console.log("state id deleteproductPopUp", this.state.product_id);
    return (
      <Modal show={true} size="md" centered onHide={this.handleClose}>
        <Modal.Header closeButton className="CNSHeader">
          <h3 className="titleMd uppercase">Delete Product</h3>
        </Modal.Header>
        <Form noValidate>
          <Modal.Body className="">
            <div className="basicInfoWrapper newServiceFormWrapper">
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Are you sure to delete this Building</Form.Label>
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer className="CNSFooter">
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
            <Button
              variant="success"
              type="button"
              onClick={this.deleteBuilding}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  };
}
export default BuildingGrid;
